// 官网用到的后端接口（都是免登录的公开接口，见后端 routers/public.py）
import request from '../utils/request'

// ---------- 站点配置 ----------
// 相对路径 /api/public/config：开发环境由 vue.config.js 代理，线上由 Nginx 代理到后端
export const getSiteConfig = () => request.get('/public/config')

// ---------- 轮播图 ----------
export const getBanners = () => request.get('/public/banners')

// ---------- 产品 ----------
export const getProductList = params => request.get('/public/products', { params })
export const getProductDetail = id => request.get(`/public/products/${id}`)

// ---------- 新闻 ----------
export const getNewsList = params => request.get('/public/news', { params })
export const getNewsDetail = id => request.get(`/public/news/${id}`)
